/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Role} from './Role';

export interface Menu {
  id: number;
  header: string;
  parentId: number;

  icon?: string;
  uri?: string;
  enabled?: boolean;
  pos?: number;
  pathMatch?: string;
  expanded?: boolean;
  submenu?: Menu[];
  roles?: Role[] | number[];
}
